/**
 * Handle login common
 *
 * @package cookie
 */

const $ = jQuery;

/**
 * Add custom method for Cookie tasting.
 *
 * @package cookie
 */
CookieTasting = Object.assign(CookieTasting, {

	getRole() {
		return this.get('role');
	},

	getApi() {
		return this.get('api');
	},

	isDigital() {
		const role = this.getRole();
		return ('business' === role || 'digital' === role);
	},

	isBusiness() {
		const role = this.getRole();
		return ('business' === role);
	},

	isReconfirm() {
		return ('1' === this.get('reconfirm'));
	},
});


/**
 * Fetch menu content.
 */
const fetchMenu = () => {
	CookieTasting.testBefore().then( res => {
		return wp.apiFetch({
			path: 'paidmedia/v1/menu',
			method: 'POST'
		});
	} ).then( response => {
		if ( true === response.success ) {
			$('.logged-in-menu-keyword').replaceWith(response.menu);
		} else {
			clearMenu();
		}
	} ).catch( response => {
		// If something wrong, clear menu.
		clearMenu();
	} );
};

/**
 * Remove menu.
 *
 * @todo Is this logic is right for flushing premium menu?
 */
const clearMenu = () => {
	$( '.tag-section .btn-mypage' ).remove();
};

if (CookieTasting.isReconfirm()){
	// When the user should be reconfirm, run confirm.
	fetchMenu() ;
} else if ( CookieTasting.isLoggedIn() ) {
	// If user is logged in, show menu.
	fetchMenu();
}

$('html').on('cookie.tasting.updated', function () {
	// Update when cookie refreshed.
	if ( CookieTasting.isLoggedIn() ) {
		fetchMenu();
	} else {
		clearMenu();
	}
});
